import { render, staticRenderFns } from "./v-take-photo.vue?vue&type=template&id=b1f6901a&scoped=true&"
import script from "./v-take-photo.vue?vue&type=script&lang=js&"
export * from "./v-take-photo.vue?vue&type=script&lang=js&"
import style0 from "./v-take-photo.vue?vue&type=style&index=0&id=b1f6901a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f6901a",
  null
  
)

export default component.exports